import React from 'react'
import { size as _size } from 'lodash'
import {
	Display,
	MarkdownText,
	SourceModal,
} from 'components'
// import { QAComponent } from '../QAComponent'
import { DaySwitchComponent } from './components'


export const AiAnswer = (props) => {
	const {
		type,
		singleKey,
        day_type,
		qa,
		questionItems,
		updatedTime,
		showList,
		showBackBtn,
        subcategory,
		width,
		// loading,
		onMenuClick,
        onDayTypeSet,
		// onQuestionSet,
        onModalToggle,
	} = props;
	const { 
        category, 
        category_code, 
        days, 
        // isDefault, 
        prompt, 
        question, 
        text,
    } = qa;
	const isThereAnswer = text && typeof text !== 'string';
	const isSmallScreen = type !== 'Chat' && width <= 1024;
    
	let answerComponent = null;
	let chartComponent = null;
	let conclusionComponent = null;
	let daySwitchComponent = null;
	let displayComponent = null;
	let qaCategory = null;
	let sourceComponent = null;
	let updatedTimeUpdated = updatedTime;
	let conclusionUpdated = [];

	if (updatedTime) {
		updatedTimeUpdated = (updatedTime.length > 0) ? updatedTime : 'N/A';
		qaCategory = questionItems
			.filter((item) => (item.account === category))[0]?.sub_account
			.filter((item) => (item.label === question))[0]?.data
			.map((item) => (item.days));
		daySwitchComponent = (
			<DaySwitchComponent
				dayType={day_type}
				data={qaCategory ?? []}
				onClick={(e) => onDayTypeSet(e.currentTarget.dataset.daytype)}
			/>
		);
	}

	if (isThereAnswer) {
		const { conclusion, display, highchart, answer, source } = text;
		const modalID = `source-${singleKey}`;

		chartComponent = ((highchart && _size(highchart) > 0)
			? (
                <div
                    id={`ai-report-${singleKey}`}
                    className='dashboard-chart'
                />
            )
			: null
		);
		conclusionUpdated = conclusion;
		conclusionComponent = conclusionUpdated
			? (
                <div className='conclusion'>
                    {conclusionUpdated.map((item, idx) => (
                        <MarkdownText children={item} key={idx} />
                    ))}
                </div>
            )
			: null;
		displayComponent = (
			<Display
				display={display
					? display.map((item) => ({ ChineseAccount: item.name, Data: item.value }))
					: []
                }
			/>
		);

		answerComponent = answer
			? <div><MarkdownText children={answer} /></div>
			: null;
		sourceComponent = (source && (!showList || !isSmallScreen))
			? (
                <div className='margin-vertical-20'>
                    <div
                        className='source ua-txt-btn txt-semibold'
                        onClick={() => onModalToggle(modalID, true)}
                    >
                        原文出處
                    </div>

                    <SourceModal
                        categoryCode={category_code}
                        days={days}
                        id={modalID}
                        question={question}
                        source={source}
                        subcategory={subcategory}
                    />
                </div>
            )
			: null;
	}

    return (
		<>
			{isThereAnswer
				? (
                    <div className={`${!isSmallScreen ? 'container' : ''}`}>
						{(/*!isDefault &&*/!showList && isSmallScreen && showBackBtn) && (
							<div className='module-header module-right-header'>
								<div role='button' className='show-list-btn' onClick={onMenuClick}>
									<i className='fas fa-chevron-left'/>
								</div>

								<h3 className='module-right-header-title column-title'>{prompt}</h3>
							</div>
						)}

						{(updatedTime && (!showList || !isSmallScreen)) && (
							<>
								<div className='updated-time'>資料更新時間：{updatedTimeUpdated}</div>

								{daySwitchComponent}
							</>
						)}

						{(conclusionComponent && (!showList || !isSmallScreen)) && (
							<>
								<div className={!isSmallScreen ? '' : 'conclusion-wrap--sm'}>
									{displayComponent}

									{conclusionComponent}
								</div>
							</>
						)}

						{(chartComponent && (!showList || !isSmallScreen)) && (chartComponent)}

						{(answerComponent && (!showList || !isSmallScreen)) && (
							<div className={/*!isDefault &&*/ isSmallScreen ? 'conclusion-wrap--sm' : ''}>
								{answerComponent}
							</div>
						)}

						{sourceComponent}

						{/*(type === 'Chat') && (
							<QAComponent
								type={type}
								item={{ text: conclusionUpdated.filter((item) => (item.includes('您的下一個問題是：') || item.includes('另外三個參考問題：'))) }}
								loading={loading}
								onQuestionSet={onQuestionSet}
							/>
						)*/}
					</div>
                )
				: <h1 className='margin-vertical-30 txt-medium text-center'>{text}</h1>}
		</>
	);
}